import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "../../core/Collection.js";
import { isNone as a, isSome as i } from "../../core/maybe.js";

var r = /*#__PURE__*/function () {
  function r() {
    _classCallCheck(this, r);

    this._isToolEditable = !0, this._manipulators = new t(), this._nextManipulatorId = 0, this._resourceContexts = {
      manipulator3D: {}
    }, this._attached = !1;
  }

  _createClass(r, [{
    key: "isToolEditable",
    set: function set(t) {
      this._isToolEditable = t;
    }
  }, {
    key: "length",
    get: function get() {
      return this._manipulators.length;
    }
  }, {
    key: "add",
    value: function add(t) {
      var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return this.addMany([t], a)[0];
    }
  }, {
    key: "addMany",
    value: function addMany(t) {
      var _this = this;

      var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return t.map(function (t) {
        var i = _this._nextManipulatorId++,
            _r = {
          id: i,
          manipulator: t,
          visibilityPredicate: a,
          attached: !1
        };
        return _this._manipulators.add(_r), _this._attached && _this._updateManipulatorAttachment(_r), i;
      });
    }
  }, {
    key: "remove",
    value: function remove(t) {
      if ("number" == typeof t) {
        var _a = t;

        for (var _t = 0; _t < this._manipulators.length; _t++) {
          if (this._manipulators.getItemAt(_t).id === _a) {
            var _a2 = this._manipulators.splice(_t, 1)[0];

            return this._detachManipulator(_a2), _a2.id;
          }
        }

        return null;
      }

      var a = t;

      for (var _i = 0; _i < this._manipulators.length; _i++) {
        if (this._manipulators.getItemAt(_i).manipulator === a) {
          var _t2 = this._manipulators.splice(_i, 1)[0];

          return this._detachManipulator(_t2), _t2.id;
        }
      }

      return null;
    }
  }, {
    key: "removeAll",
    value: function removeAll() {
      var _this2 = this;

      this._manipulators.forEach(function (t) {
        _this2._detachManipulator(t);
      }), this._manipulators.removeAll();
    }
  }, {
    key: "attach",
    value: function attach() {
      var _this3 = this;

      this._manipulators.forEach(function (t) {
        _this3._updateManipulatorAttachment(t);
      }), this._attached = !0;
    }
  }, {
    key: "detach",
    value: function detach() {
      var _this4 = this;

      this._manipulators.forEach(function (t) {
        _this4._detachManipulator(t);
      }), this._attached = !1;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._manipulators.forEach(function (_ref) {
        var t = _ref.manipulator;
        t.destroy && t.destroy();
      }), this._manipulators.destroy(), this._resourceContexts = null;
    }
  }, {
    key: "on",
    value: function on(t, a) {
      return this._manipulators.on(t, function (t) {
        a(t);
      });
    }
  }, {
    key: "forEach",
    value: function forEach(t) {
      var _iterator = _createForOfIteratorHelper(this._manipulators.items),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _a3 = _step.value;
          t(_a3);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "some",
    value: function some(t) {
      return this._manipulators.items.some(t);
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var t = [];
      return this.forEach(function (a) {
        return t.push(a.manipulator);
      }), t;
    }
  }, {
    key: "intersect",
    value: function intersect(t, a) {
      var _r2 = null,
          e = Number.MAX_VALUE;
      return this._manipulators.forEach(function (_ref2) {
        var s = _ref2.id,
            o = _ref2.manipulator,
            n = _ref2.attached;
        if (!n || !o.interactive) return;
        var l = o.intersectionDistance(t, a);
        i(l) && l < e && (e = l, _r2 = {
          id: s,
          manipulator: o
        });
      }), _r2;
    }
  }, {
    key: "findById",
    value: function findById(t) {
      if (a(t)) return null;

      var _iterator2 = _createForOfIteratorHelper(this._manipulators.items),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _a4 = _step2.value;
          if (t === _a4.id) return _a4.manipulator;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return null;
    }
  }, {
    key: "_updateManipulatorAttachment",
    value: function _updateManipulatorAttachment(t) {
      this._isManipulatorItemVisible(t) ? this._attachManipulator(t) : this._detachManipulator(t);
    }
  }, {
    key: "_attachManipulator",
    value: function _attachManipulator(t) {
      t.attached || (t.manipulator.attach && t.manipulator.attach(this._resourceContexts), t.attached = !0);
    }
  }, {
    key: "_detachManipulator",
    value: function _detachManipulator(t) {
      if (!t.attached) return;
      var a = t.manipulator;
      a.grabbing = !1, a.dragging = !1, a.hovering = !1, a.selected = !1, a.detach && a.detach(this._resourceContexts), t.attached = !1;
    }
  }, {
    key: "_isManipulatorItemVisible",
    value: function _isManipulatorItemVisible(t) {
      return 2 === t.visibilityPredicate || (this._isToolEditable ? 0 === t.visibilityPredicate : 1 === t.visibilityPredicate);
    }
  }]);

  return r;
}();

export { r as ManipulatorCollection };